import { render, staticRenderFns } from "./peopleDialog.vue?vue&type=template&id=4f11f186&scoped=true"
import script from "./peopleDialog.vue?vue&type=script&lang=js"
export * from "./peopleDialog.vue?vue&type=script&lang=js"
import style0 from "./peopleDialog.vue?vue&type=style&index=0&id=4f11f186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f11f186",
  null
  
)

export default component.exports